import config from "../boot/config";
import http from "../boot/http.js";

const route = "Ticket/";
const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default class {
    static GetLive(from, to, siteId) {
      if(config.hasTicketEnabled == true) {
       let url = `${config.baseUrl + route}GetLive`;
         return http({ url, method: "GET", params: { from: from.format(dateFormat), to: to.format(dateFormat), siteId: siteId } })
           .then(data => data)
           .catch(error => error);
      } else {
         return [];
      }
    }

   static GetLiveSnapshot(siteids) {
     if(config.hasTicketEnabled == true) {
       let url = `${config.baseUrl + route}GetLiveSnapshot`;
       return http({ url, method: "POST", data: siteids })
           .then(data => data)
           .catch(error => error);
     } else {
       return [];
     }
   }

   static GetTicketsSold(siteids, from, to, noformat) {
     if(config.hasTicketEnabled == true) {
      let url = `${config.baseUrl + route}GetTicketsSold`;
      return http({ url, method: "POST", data: siteids, params: {from: noformat ? from : from.format(dateFormat), to: noformat ? to : to.format(dateFormat) } })
          .then(data => data)
          .catch(error => error);
     } else {
       return [];
     }
   }

}



// WEBPACK FOOTER //
// ./src/services/ticket.js